import { Modal, ModalFooter, ModalHeader } from '@msdyn365-commerce-modules/utilities';
import { MediaLocation } from '@msdyn365-commerce/retail-proxy';
import React, { useEffect, useRef, useState } from 'react';
import { ICipDocumentsViewProps } from './cip-documents';
import CipDocumentsCard from './components/cip-documents-card';

const CipDocuments: React.FC<ICipDocumentsViewProps> = props => {
    const { additionalMediaLocations } = props.data;
    const [selectedPurpose, setSelectedPurpose] = useState<string>(props.resources.cipDocumentsFilterAllKey);
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [modalContent, setModalContent] = useState<JSX.Element | null>(null);

    const CLASS_NAME = 'cip-documents';

    const allDocs: MediaLocation[] = additionalMediaLocations?.result ?? [];
    console.log(props.data);

    if (allDocs.length === 0) {
        return null;
    }

    const modalRootRef = useRef<HTMLDivElement>(null);

    const purposes = Array.from(new Set(allDocs.map(doc => doc.MediaPurpose || props.resources.cipDocumentsFilterNoKey)));

    useEffect(() => {
        if (!isModalOpen) {
            return;
        }

        const handleClick = (event: MouseEvent) => {
            if (modalRootRef.current && !modalRootRef.current.contains(event.target as Node)) {
                setIsModalOpen(false);
            }
        };
        document.addEventListener('mousedown', handleClick);
        return () => {
            document.removeEventListener('mousedown', handleClick);
        };
    }, [isModalOpen]);

    const filteredDocs =
        selectedPurpose === props.resources.cipDocumentsFilterAllKey
            ? allDocs
            : allDocs.filter(doc => (doc.MediaPurpose || props.resources.cipDocumentsFilterNoKey) === selectedPurpose);

    const FilterSection: React.FC = () => (
        <div className={`${CLASS_NAME}__filter`}>
            <button
                className={`${CLASS_NAME}__filter-button msc-cta__secondary ${
                    selectedPurpose === props.resources.cipDocumentsFilterAllKey ? 'active' : ''
                }`}
                type='button'
                onClick={() => setSelectedPurpose(props.resources.cipDocumentsFilterAllKey)}
            >
                {props.resources.cipDocumentsFilterAllKey}
            </button>
            {purposes.map(purpose => (
                <button
                    key={purpose}
                    className={`${CLASS_NAME}__filter-button msc-cta__secondary ${selectedPurpose === purpose ? 'active' : ''}`}
                    type='button'
                    onClick={() => setSelectedPurpose(purpose)}
                >
                    {purpose}
                </button>
            ))}
        </div>
    );

    return (
        <div className={CLASS_NAME}>
            <h2 className={`${CLASS_NAME}__heading`}>{props.resources.cipDocumentsHeading}</h2>
            {props.config.showFilters && <FilterSection />}
            <CipDocumentsCard
                documents={filteredDocs}
                resources={props.resources}
                CLASS_NAME={CLASS_NAME}
                setModalContent={setModalContent}
                setIsModalOpen={setIsModalOpen}
                showFilters={props.config.showFilters ?? false}
            />

            {isModalOpen && (
                <Modal
                    className='msc-modal-input-required cip-documents__modal'
                    wrapClassName=''
                    autoFocus
                    fade={false}
                    applicationNode='renderPage'
                    isOpen={true}
                >
                    <div ref={modalRootRef}>
                        <ModalHeader tag='h3' toggle={() => setIsModalOpen(false)} />
                        {modalContent}
                        <ModalFooter />
                    </div>
                </Modal>
            )}
        </div>
    );
};

export default CipDocuments;
